import React, { useEffect } from "react";
import DescriptionFields from "../Description/DescriptionFields";
import { NavigationalButtons } from "./CreateCourseWizard";
import { Form, Formik } from "formik";
import useAxios from "axios-hooks";
import { Spinner } from "@fluentui/react";

const DescriptionStep = ({ courseId, revId, nextOnClick, prevOnClick }) => {

    const [{loading: submitting }, postForm] = useAxios(
        {
            url: `/courses/${courseId}/description`,
            method: "put",
        },
        { manual: true }
    );

    const [{ data: course, loading }] = useAxios(`courses/${courseId}/${revId || ''}`);

    if (loading)
        return <Spinner className="absolute-center" label="Loading..." />;

    return (
        <div>
            <Formik
                initialValues={{
                    crsCourseTypeId: course.crsCourseTypeId,
                    crsLevelId: course.levelId,
                    lengthMinutes: course.length,
                    shortDescription: course.shortDescription || '',
                    longDescription: course.longDescription || '',
                    numVideoMinutes: course.numVideoMinutes || 0,
                    numInteractiveExercises: course.numInteractiveExercises || 0,
                    incVideo: course.incVideo || false,
                    incExAndGraph: course.incExAndGraph || false,
                    incQuizzes: course.incQuizzes || false,
                    incPersonalization: course.incPersonalization || false
                }}
                onSubmit={async (values) => {
                    const result = await postForm({ data: values });

                    if (!result.isAxiosError) {
                        nextOnClick();
                    }
                }}
            >
                <Form style={{width: 500}}>
                    <DescriptionFields />
                    <NavigationalButtons
                        loading={submitting}
                        onNextProps={{ type: "submit", text: "Save and Continue" }}
                        onPrevHandler={prevOnClick}
                    />
                </Form>
            </Formik>
        </div>
    );
};

export default DescriptionStep;
